import { render } from "./CashierDashboardPage.vue?vue&type=template&id=9399dd18"
import script from "./CashierDashboardPage.vue?vue&type=script&lang=js"
export * from "./CashierDashboardPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/cose-cashier/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__